import type { TableChoiceMemory, Variant } from "@app/protocol";
import { normalizeRules } from "@app/rules";
import type { TableChoice } from "./CreateTable";

/** The table set-up without its looks, which remember themselves (decision 118). */
export type TableSetup = Omit<TableChoice, "scene" | "deck">;

/** What to store after "Open the table": this game's target and rules join the others kept (slice 0038). Pure. */
export function rememberTable(
  previous: TableChoiceMemory | null,
  setup: TableSetup,
): TableChoiceMemory {
  return {
    variant: setup.variant,
    tempo: setup.tempo,
    listed: setup.listed,
    games: { ...previous?.games, [setup.variant]: { goal: setup.goal, rules: setup.rules } },
  };
}

/** A game's target and rules as last set up; its own defaults and the current target otherwise. Pure. */
export function gameSetup(
  memory: TableChoiceMemory | null,
  variant: Variant,
  currentGoal: number | null,
): Pick<TableSetup, "goal" | "rules"> {
  const kept = memory?.games[variant];
  return {
    goal: kept === undefined ? currentGoal : kept.goal,
    rules: normalizeRules(variant, kept?.rules ?? {}),
  };
}

/** The home screen's starting set-up: the last one set up when there is one, else the table's own. Pure. */
export function recallTable(fromTable: TableSetup, memory: TableChoiceMemory | null): TableSetup {
  if (memory === null) return fromTable;
  return {
    variant: memory.variant,
    tempo: memory.tempo,
    listed: memory.listed,
    ...gameSetup(memory, memory.variant, fromTable.goal),
  };
}
